import { render, staticRenderFns } from "./cModalNewFloorBed.vue?vue&type=template&id=1709056c"
import script from "./cModalNewFloorBed.vue?vue&type=script&lang=js"
export * from "./cModalNewFloorBed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports